module.exports = __webpack_public_path__ + "static/media/new_pack_dog_EN_285x350.248866c1.png";